import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
  return <LegalPage kind="privacy" />;
}
